import GIFsSearch from './GIFsSearch';

export * from './GIFsSearch';
export default GIFsSearch;
